/**
 * Any admin page can open the top-bar search, Ask ANNA, a guide or a guided tour
 * without being wired to the admin layout: GlobalSearch and TourLayer listen for these.
 */
export const OPEN_EVENT = 'anna:open';
export const TOUR_EVENT = 'anna:tour';

const send = (name, detail) => window.dispatchEvent(new CustomEvent(name, { detail }));

/** Opens the search with `query` typed in. */
export const openSearch = (query = '') => send(OPEN_EVENT, { mode: 'search', text: query });

/** Opens Ask ANNA; with a question, asks it right away. */
export const askAnna = (question = '') => send(OPEN_EVENT, { mode: 'ai', text: question });

/** Opens one guide, or the list of guides when no id is given. */
export const openGuide = (id) => send(OPEN_EVENT, id ? { mode: 'guide', id } : { mode: 'guides' });

/** Starts a guide's tour. */
export const startTour = (id) => send(TOUR_EVENT, { id });
